import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import Close from '../Close';
import dynamic from 'next/dynamic';

const Modal = dynamic(() => import('../Modal'), {
  ssr: false,
});

export default function ImageZoomModal({ children, classname, isWidthAuto = true }) {
  const [isVisible, setIsVisible] = useState(false);
  const [isZoom, setIsZoom] = useState(false);
  const [scrollPosition, setScrollPosition] = useState(0);

  const handleOpenModal = () => {
    if (typeof window === 'undefined') return;
    setScrollPosition(window.scrollY);
    setIsVisible(true);
  };

  const handleCloseModal = () => {
    setIsVisible(false);
    setIsZoom(false);
  };

  useEffect(() => {
    // scroll back to clicked image
    if (!isVisible) {
      document.body.style.overflow = 'unset';
      document.getElementById('__next').style.overflow = 'unset';
      window.scroll({
        top: scrollPosition,
        left: 0,
        behavior: 'instant',
      });
    }
  }, [isVisible]);

  return (
    <>
      <button
        className={`cursor-zoom-in inline-block w-full h-full ${isWidthAuto && 'lg:w-auto'}`}
        onClick={handleOpenModal}
      >
        <div className="h-full">{children}</div>
      </button>
      {typeof document !== 'undefined' &&
        createPortal(
          <Modal
            visible={isVisible}
            onClose={handleCloseModal}
            modalClassName={`z-[120] bg-reliableBlack bg-opacity-[0.95] ${classname}`}
            bodyClassName="overflow-hidden"
            className={`aspect-video [&_img]:w-full [&_img]:h-full w-full ${isZoom ? 'lg:w-[90vw]' : 'lg:w-[50vw]'} `}
          >
            <button
              onClick={handleCloseModal}
              className="p-1 absolute right-0 -top-8 lg:-right-1 lg:-top-10"
              aria-label="button-close-image-zoom-modal"
            >
              <Close size={18} fill="#fff" />
            </button>
            <button
              className={`w-full h-full ${isZoom ? 'cursor-zoom-out' : 'cursor-zoom-in'}`}
              onClick={() => setIsZoom((prev) => !prev)}
            >
              {children}
            </button>
          </Modal>,
          document.body
        )}
    </>
  );
}
